import { sogUnlocodeRoutes } from '@dfds-pax/utils'

const MULTIPLE_VEHICLES_UNSUPPORTED_ROUTES = [
  'FRCQF-GBDVR',
  'FRDKK-GBDVR',
  'FRDPE-GBNHV',
  'GBDVR-FRCQF',
  'GBDVR-FRDKK',
  'GBNHV-FRDPE',
  'GBPME-JESTH',
  'GBPOO-JESTH',
  'JESTH-GBPME',
  'JESTH-GBPOO',
  'JESTH-FRSML',
  'FRSML-JESTH',
]

// SoG routes and the routes listed above never support multiple vehicles.
export const isMultipleVehiclesSupportedWithRoute = (routeCode: string): boolean =>
  !MULTIPLE_VEHICLES_UNSUPPORTED_ROUTES.includes(routeCode) && !sogUnlocodeRoutes.includes(routeCode)

export const isMultipleVehiclesSupportedWithVehicleType = (routeCode: string): boolean => {
  // Vehicles
  if (routeCode === 'NCAR') return false
  return true
}
export const getMultipleVehicleSelectedCount = (count: number) => {
  if (!count) return ''
  if (count < 2) return ''
  if (count > 1) return `${count.toString()} `
}

const RESIDENT_VEHICLE_ROUTES = ['ESCEU-ESALG', 'ESALG-ESCEU']

export const isResidentVehicleRoute = (routeCode: string): boolean => RESIDENT_VEHICLE_ROUTES.includes(routeCode)

export const showResidentVehicleToggle = (routeCode: string, locale: string): boolean =>
  isResidentVehicleRoute(routeCode) && locale !== 'fr-ma'

// Map a vehicle code to its resident/non-resident counterpart so the same vehicle
// stays selected when the resident toggle is switched (e.g. 'ABC' <-> 'ABCRES').
export const mapVehicleCodeToResidentSet = (code: string, showResident: boolean): string => {
  if (showResident) return code.endsWith('RES') ? code : `${code}RES`
  return code.endsWith('RES') ? code.slice(0, -3) : code
}
